module.exports = __webpack_public_path__ + "img/teaser_hund3.eec22eec.jpg";